import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
var is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints // works on most browsers
  ;
};
var html = document.querySelector('html');
if (is_touch_device()) {
  html.classList.add('is-touch-device');
} else {
  html.classList.add('is-not-touch-device');
}

document.querySelector('.algolia-icon-search').addEventListener('click', function (e) {
  e.preventDefault();
  e.target.classList.toggle('show-search');
  var searchDropdown = document.querySelector('.algolia-searchdrop');
  searchDropdown.classList.toggle('show-search');

  var mobileNav = document.querySelector('.mobile-nav-parent');
  mobileNav.classList.toggle('show-search');

  if (searchDropdown.classList.contains('show-search')) {
    window.scrollTo(0, 0);
    document.getElementById('algolia-search-input').focus();
  }
});

// pink underline button text animation
var clickFlyLinks = document.querySelectorAll('.click-fly-animation');
[].concat(_toConsumableArray(clickFlyLinks)).forEach(function (link) {
  link.addEventListener('click', function (e) {
    e.target.classList.add('click_fly');
    var pinkButton = e.target.querySelector('.pink-underline-button');
    pinkButton ? pinkButton.classList.add('click_fly') : null;
  });
});

document.querySelector('.skip-to-main').addEventListener('click', function () {
  document.querySelector('.main-content').focus();
  return false;
});

var megaMenuToggles = document.querySelectorAll('html.is-touch-device .has-mega-dropdown a.nav-list__item__link');
[].concat(_toConsumableArray(megaMenuToggles)).forEach(function (toggle) {
  toggle.addEventListener('click', function (e) {
    // Don't link out because its a touch device, instead open mega menu
    e.preventDefault();
  });
});